import { render, staticRenderFns } from "./BenificiaryRelationComponent.vue?vue&type=template&id=64fe357f&"
import script from "./BenificiaryRelationComponent.vue?vue&type=script&lang=js&"
export * from "./BenificiaryRelationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports